export default {
  slug: "koog",
  code: "KG",
  label: "Koog",
  krakenDir: "Koog",
  logoFamily: "jb",
};
